import React from 'react';
import { Award, Edit3, Trash2 } from 'lucide-react';

const DiplomeCard = ({ diplome, typesDiplome, niveauxEtude, domainesFormation, onEdit, onDelete }) => {
    // Générer une couleur pastel aléatoire mais consistante pour chaque niveau d'étude
    const niveauId = diplome.niveau_etude || 0;
    const hue = (niveauId * 137) % 360;
    const bgColor = `hsla(${hue}, 70%, 85%, 0.2)`;
    const accentColor = `hsla(${hue}, 70%, 45%, 1)`;

    const getTypeDiplomeNom = (diplomeId) => {
        if (diplomeId === null) return diplome.autre || 'Non spécifié';
        const type = typesDiplome.find(t => t.id === diplomeId);
        return type ? type.nom : 'Non spécifié';
    };

    const getNiveauEtudeNom = (niveauId) => {
        const niveau = niveauxEtude.find(n => n.id === niveauId);
        return niveau ? niveau.niveau : 'Non spécifié';
    };

    const getDomaineNom = (domaineId) => {
        const domaine = domainesFormation.find(d => d.id === domaineId);
        return domaine ? domaine.nom : null;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    return (
        <div
            className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition duration-300 transform hover:-translate-y-1"
            style={{ borderTop: `4px solid ${accentColor}` }}
        >
            <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                    <div className="flex items-center">
                        <div
                            className="p-3 rounded-full mr-3"
                            style={{ backgroundColor: bgColor }}
                        >
                            <Award className="h-6 w-6" style={{ color: accentColor }} />
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold text-gray-800">
                                {diplome.diplome === null ? diplome.autre : getTypeDiplomeNom(diplome.diplome)}
                            </h3>
                            <p className="text-sm text-gray-600">
                                {getNiveauEtudeNom(diplome.niveau_etude)}
                            </p>
                        </div>
                    </div>
                    <div className="flex space-x-1">
                        <button
                            onClick={() => onEdit(diplome)}
                            className="bg-orange-50 hover:bg-orange-100 text-orange-600 p-2 rounded-full transition-colors duration-200"
                            title="Modifier"
                        >
                            <Edit3 size={16} />
                        </button>
                        <button
                            onClick={() => onDelete(diplome.id)}
                            className="bg-red-50 hover:bg-red-100 text-red-600 p-2 rounded-full transition-colors duration-200"
                            title="Supprimer"
                        >
                            <Trash2 size={16} />
                        </button>
                    </div>
                </div>

                <div className="mt-4 space-y-3">
                    <div className="flex items-start">
                        <span className="text-sm font-medium text-gray-500 w-28">Établissement:</span>
                        <span className="text-sm text-gray-700 flex-1">{diplome.etablissement}</span>
                    </div>
                    <div className="flex items-start">
                        <span className="text-sm font-medium text-gray-500 w-28">Obtention:</span>
                        <span className="text-sm text-gray-700 flex-1">{formatDate(diplome.date_obtention)}</span>
                    </div>
                    <div className="flex items-start">
                        <span className="text-sm font-medium text-gray-500 w-28">Pays:</span>
                        <span className="text-sm text-gray-700 flex-1">{diplome.pays}</span>
                    </div>
                    {diplome.domaine_formation && (
                        <div className="flex items-start">
                            <span className="text-sm font-medium text-gray-500 w-28">Domaine:</span>
                            <span className="text-sm text-gray-700 flex-1 font-medium" style={{ color: accentColor }}>
                                {getDomaineNom(diplome.domaine_formation)}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DiplomeCard;
